// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00b84dcc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/index/loginDianxin.vue
// module id = 1040
// module chunks = 0